// extracted by mini-css-extract-plugin
export default {"greenMap":"service-states-map-module--green-map--27MSg","whiteMap":"service-states-map-module--white-map--3PrLM"};